import { Injector } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { storage as storageCatalog } from '../utils/catalog';
import Migration from './migration';

export default class Objects extends Migration {
  constructor() {
    super(1);
  }

  public async up(injector: Injector): Promise<void> {
    const storageService = injector.get(StorageService);

    const objects = storageService.get(storageCatalog.keys.objects);
    if (objects) return;

    const auth = storageService.get(storageCatalog.keys.auth);
    if (!auth) return;

    storageService.put(storageCatalog.keys.objects, [auth]);
  }
}
